import React from "react";
import "../organisationCard.css";
import { Organisation } from "../../../features/organisation/organisationTypes";
import OrganisationContactInfo from "../organisationContactInfo";
import OrganisationServiceTypeInfo from "../organisationServiceTypeInfo";
import OrganisationModalAdditionalInfo from "./organisationModalAdditionalInfo";
import { ColumnFlexBox } from "../../common/FlexBoxes";
import { ParagraphSmall } from "@tal-gel/components-v2";

interface propsFromComponent {
  item: Organisation;
}

type Props = propsFromComponent;

const OrganisationMobileModal: React.FC<Props> = ({ item }) => {
  return (
    <ColumnFlexBox style={{ alignItems: "stretch", gap: "16px" }}>
      <ParagraphSmall>{item.description}</ParagraphSmall>
      <OrganisationContactInfo item={item} />
      <OrganisationModalAdditionalInfo item={item} />
      <OrganisationServiceTypeInfo item={item} />
    </ColumnFlexBox>
  );
};

export default OrganisationMobileModal;
